import { createFileRoute } from "@tanstack/react-router";
import { LegalPage } from "@/components/landing/LegalPage";
import { SITE } from "@/config/site";

export const Route = createFileRoute("/privacidade")({
  head: () => ({
    meta: [
      { title: "Política de Privacidade — Prime Saúde Benefícios" },
      {
        name: "description",
        content: "Como a Prime Saúde Benefícios trata seus dados pessoais, conforme a LGPD.",
      },
      { property: "og:title", content: "Política de Privacidade — Prime Saúde Benefícios" },
      {
        property: "og:description",
        content: "Como tratamos seus dados pessoais, conforme a LGPD.",
      },
      { property: "og:type", content: "article" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: () => (
    <LegalPage title="Política de Privacidade">
      <p>
        A Prime Saúde Benefícios respeita sua privacidade e trata seus dados pessoais de acordo com
        a Lei Geral de Proteção de Dados (Lei nº 13.709/2018).
      </p>
      <h2>Dados coletados</h2>
      <p>
        Nome, WhatsApp, cidade/estado, tipo de plano, quantidade e idades dos beneficiários. Não
        coletamos dados sensíveis de saúde.
      </p>
      <h2>Finalidade</h2>
      <p>
        Os dados são usados exclusivamente para elaborar e enviar cotações de planos de saúde e para
        contato comercial relacionado.
      </p>
      <h2>Compartilhamento</h2>
      <p>
        Os dados podem ser compartilhados com operadoras de planos de saúde apenas para viabilizar a
        cotação solicitada.
      </p>
      <h2>Seus direitos</h2>
      <p>
        Você pode solicitar acesso, correção ou exclusão dos seus dados a qualquer momento pelo
        e-mail {SITE.email}.
      </p>
      <h2>Cookies e métricas</h2>
      <p>
        Podemos utilizar ferramentas de análise e publicidade (como Google Analytics, Google Ads e
        Meta Pixel) para medir o desempenho do site.
      </p>
    </LegalPage>
  ),
});
